import { Outlet } from 'react-router-dom';

const SocialSecurity = () => {
    return (
        <>
            <Outlet />
        </>
    )
};

export default SocialSecurity;